import React from "react";

import { credentialsManager } from "../auth";

interface AuthContextData {
  authenticated: boolean;
}

export function useAuth(): AuthContextData {
  // Asumption: if stored credential are found, they must be valid
  // These stored credentials must be validated by the root React component when the SPA
  // loads for first time
  const storedCredentials = credentialsManager.readCredentialsFromLocalStorage();

  if (storedCredentials === null) {
    return { authenticated: false };
  }

  return { authenticated: true };
}

const AuthContext = React.createContext<AuthContextData>({ authenticated: false });

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
